module.exports = __webpack_public_path__ + "static/media/SarahSwitek_06_EnergyLevel-Introduction_1.26d86402.mp3";